const getSubpath = (location) => {
	const start = location.lastIndexOf("/");
	if (start === 0) {
		return "";
	}
	return location.substr(start + 1);
};

export default getSubpath;
